import React from 'react';
import { get, isEmpty } from 'lodash-es';
import T from 'prop-types';

import skeletons from './Skeletons';
import DetailsEmpty from './DetailsEmpty';
import Xray from '../Xray';
import Button from '../../../../../components/Buttons/Button';

import links from '../../config/links';

const InsightsXray = ({ details, settings }) => {
  const tags = get(details, 'x_ray_tags');
  const refNo = get(details, 'app_about.about_data.app_id', '');
  const filters = get(details, 'filters');

  if (settings.pending) return skeletons.detailsTable;
  const showData = !settings.pending && !isEmpty(tags);

  return (
    <div className="insights-details-block">
      <h4 className="insights-details-block__head h4">
        <div className="insights-details-block__head-left">Features (X-Ray)</div>
        {showData && (
          <Button size="sm" variant="secondary" href={links.xray(filters.store, refNo)}>
            <span>View All</span>
            <i className="hicon-angle-down-new" />
          </Button>
        )}
      </h4>
      <div className="insights-details-block__content">
        {showData ? <Xray tags={tags} store={filters.store} /> : <DetailsEmpty />}
      </div>
    </div>
  );
};

InsightsXray.propTypes = {
  details: T.object,
  settings: T.object,
};

export default InsightsXray;
